import hasPermi from './permission/hasPermi'
import hasPermiFn from './permission/hasPermiFn'
import preventClick from './permission/preventClick'
const install = function(Vue) {
  Vue.directive('hasPermi', hasPermi)
  Vue.use(hasPermiFn);
  Vue.use(preventClick);
}

if (window.Vue) {
  window['hasPermi'] = hasPermi
  Vue.use(install); // eslint-disable-line
  Vue.use(hasPermiFn); // eslint-disable-line
  Vue.use(preventClick); // eslint-disable-line
}

export default install



// WEBPACK FOOTER //
// ./src/directive/index.js